import { Component, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';
import { ButtonTypeEnum } from '@panaya/ui/p-button';

@Component({
    selector: 'p-dialog-container',
    template: `
        <p-button
            *ngIf="!closeEvent.observed"
            class="p-dialog-close"
            ariaLabel="Close Dialog"
            [buttonType]="buttonType.IsIcon"
            iconBefore="x"
            iconBeforeSize="lg"
            iconBeforeColor="base-light"
            mat-dialog-close
        ></p-button>
        <p-button
            *ngIf="closeEvent.observed"
            class="p-dialog-close"
            ariaLabel="Close Dialog"
            [buttonType]="buttonType.IsIcon"
            iconBefore="x"
            iconBeforeSize="lg"
            iconBeforeColor="base-light"
            (click)="closeEvent.emit()"
        ></p-button>
        <div class="p-dialog-wrapper-inner">
            <ng-content></ng-content>
        </div>
    `,
    styleUrls: ['./p-dialog-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PDialogContainerComponent {
    public buttonType = ButtonTypeEnum;
    @Output() closeEvent = new EventEmitter<void>();
}
